import { render, staticRenderFns } from "./PasswordRestore.vue?vue&type=template&id=3cc68f57&"
import script from "./PasswordRestore.vue?vue&type=script&lang=js&"
export * from "./PasswordRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports